import { render, staticRenderFns } from "./ListagemRegistros.vue?vue&type=template&id=170508d4&scoped=true&"
import script from "./ListagemRegistros.vue?vue&type=script&lang=js&"
export * from "./ListagemRegistros.vue?vue&type=script&lang=js&"
import style0 from "./ListagemRegistros.vue?vue&type=style&index=0&id=170508d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170508d4",
  null
  
)

export default component.exports